import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { TierInfo } from "@customTypes/earnings";

import { earningsQKeys } from "./queryKeys";

export const useGetMyTier = (isEnabled = true) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: earningsQKeys.tier(),
    queryFn: async () => {
      const { data } = await api.get<TierInfo>("earnings/my/tier");
      return data;
    },
    enabled: isEnabled,
    onError: (res: any) => {
      console.error("[From Get My Tier]", res);
      handleErrors(res, "query");
    },
  });
};
